import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { openModal } from "risa-oasis-ui_v2";
import { getFileDownloadUrl } from "../../../../api/firebase/firestoreService";
import CustomTable from "../../../../components/custom-table/custom-table";
import NycbsMedicalPaDetailsModal from "../../../../components/modals/nycbsMedicalPaDetailsModal/nycbsMedicalPaDetailsModal";
import { EligibilityCheckTableData } from "../../../../data-model/tablesData";
import { RootState } from "../../../../redux/store/store";
import { logDataToConsole, logError } from "../../../../utils/customLogger";
import {
  ClaimsTableHeader,
  generateClaimsTableData,
  updateClaimsDownloadStatusOfOrderWithId,
} from "../../utils/claimsTableDataGenerator";

const ClaimsTable = () => {
  const { data, loading } = useSelector(
    (state: RootState) => state.nycbsClaimsPa,
  );

  const [claimsTableData, setClaimsTableData] = useState<
    EligibilityCheckTableData[]
  >([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState<string | null>(null);

  const handleDownload = (fileUrl: string, fileName: string) => {
    try {
      const link = document.createElement("a");
      link.href = fileUrl;
      link.setAttribute("download", fileName || "file.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(fileUrl);
    } catch (error) {
      logError(error as Error, "Error while downloading claims file");
    }
  };

  const handleDownloadOfReportFromRef = async (rowData) => {
    const id = rowData?.id ?? "";
    setClaimsTableData(
      updateClaimsDownloadStatusOfOrderWithId(claimsTableData, id, false),
    );
    const fileRef = data?.find((el) => el.job_id === id)?.report_url ?? "";
    if (fileRef) {
      const fileUrl = await getFileDownloadUrl(fileRef);
      handleDownload(fileUrl, `${id}_claims_report.xlsx`);
      setClaimsTableData(
        updateClaimsDownloadStatusOfOrderWithId(claimsTableData, id, true),
      );
    }
  };

  useEffect(() => {
    if (data) {
      setClaimsTableData(generateClaimsTableData(data));
    }
  }, [data]);

  useEffect(() => {
    if (showModal) {
      openModal("nycbs-medical-pa-details");
    }
  }, [showModal]);
  return (
    <>
      <CustomTable
        tableHeaders={ClaimsTableHeader}
        tableData={claimsTableData}
        tableName={"claims-table"}
        hideSearchBar={true}
        count={claimsTableData.length}
        totalCount={claimsTableData.length}
        pagesPerView={5}
        itemsPerPage={10}
        endIndexOfTable={() => {}}
        isFetching={loading}
        onReviewButtonClick={(data) => {
          setSelectedOrderId(data.id);
          setShowModal(true);
        }}
        onClickableTextWithDisabledStatusClick={(data) => {
          handleDownloadOfReportFromRef(data);
          logDataToConsole(data);
        }}
      />
      {showModal && (
        <NycbsMedicalPaDetailsModal
          onClose={() => setShowModal(false)}
          id={selectedOrderId ?? ""}
        />
      )}
    </>
  );
};

export default ClaimsTable;
